import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import '../scss/styles.scss';

window.$ = $;
window.jQuery = $;

document.addEventListener('DOMContentLoaded', async () => {
	await import('lightslider');

	var header = $('.navbar-expand-md');

	$(window).on('scroll', function () {
		var scroll = $(window).scrollTop();

		if (scroll >= 400) {
			header.addClass('filled');
		} else {
			header.removeClass('filled');
		}
	});

	$('.slider').lightSlider({
		pager: false,
		item: 1,
		loop: true,
	});

	$('.hero-logos .slider').lightSlider({
		item: 6,
		slideMargin: 0,
		controls: false,
		auto: true,
		loop: true,
		pause: 2500,
		keyPress: false,
		nextHtml: '',
		prevHtml: '',
		pager: false,
		enableDrag: true,
	});

	var slider = $('#ambassadors-slider').lightSlider({
		item: 1,
		slideMargin: 0,
		controls: false,
		auto: true,
		loop: true,
		pause: 5000,
		keyPress: false,
		nextHtml:
			"<button type='button' class='home-amba-navigator right w-50'><i class='fa fa-arrow-right'></i></button>",
		prevHtml:
			"<button type='button' class='home-amba-navigator left w-50'><i class='fa fa-arrow-left'></i></button>",
		pager: false,
		enableDrag: false,
		mode: 'fade',
	});

	$('.lSAction > .lSPrev').on('click', function () {
		slider.goToPrevSlide();
	});

	$('.lSAction > .lSNext').on('click', function () {
		slider.goToNextSlide();
	});

	const termsField = document.getElementById('field_terms');

	if (termsField) {
		termsField.addEventListener('invalid', function () {
			this.setCustomValidity(
				'Please indicate that you accept the Terms and Conditions',
			);
		});

		termsField.addEventListener('input', function () {
			this.setCustomValidity('');
		});
	}
});
